
import { writable } from "svelte/store";
import moment from "moment";

// We keep this separate from the TimeSlider for a number of reasons.
// * We can make it always available from instantiation
// * We don't have to fight the component lifecycle (data not being available before mount/bind)
// * Separation of visuals and data is good practice / more "pure".
class TimeSliderData {
	constructor() {
		this.instance = null;

		this.value = writable(moment(new Date()));
		this.min = writable(moment(new Date()));
		this.max = writable(moment(new Date()));

		// Increment the time slider component in increments of 5 minutes. Measured in seconds.
		this.step = writable(60 * 5);
	}
}
export default TimeSliderData;
